import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ComponentDialogAlertProperties } from './component.dialog.alert.interface';

@Component({
    templateUrl: './component.dialog.alert.html',
    styleUrls: ['./component.dialog.alert.css']
})
export class ComponentDialogAlert{
    
    dataDialog: ComponentDialogAlertProperties;
    icon: string;
    showFooter: boolean = true;
    
    constructor(
        public dialogRef: MatDialogRef<ComponentDialogAlert>, 
        @Inject(MAT_DIALOG_DATA) public data: ComponentDialogAlertProperties
    ){
        this.dataDialog = data;
        
        switch(data.type){
            case 0: {
                this.icon = 'cancel';
                break;
            }
            case 1: {
                this.icon = 'check_circle';
                break;
            }
            case 2: {
                this.icon = 'error';
                break;
            }
            case 3: {
                this.icon = 'feedback';
                break;
            }
        }

        if(data.stopProcess){
            this.showFooter = false;
        }
    }

    onClickAccept(){
        this.dialogRef.close();
    }

}